onDomReady(() => {
   when($$('.js-page-navigation'), ContentDropdownGroup);
});
